module.exports = __webpack_public_path__ + "4abda15b0ce100385634f96d0e5a7de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/newzealand_icon.png
// module id = 1228
// module chunks = 0